import {Component} from "react"
import WeatherList from "./WeatherList"
import {Vortex} from "react-loader-spinner"
import "./index.css"

const apiStatusContant = {
    initial: "INITIAL",
    success: "SUCCESS",
    failure: "FAILURE",
    inProgress: "IN_PROGRESS"
}



class WeatherApp extends Component {
    state={searchedData:{},changeTemp: false,inputValue: "",apiStatus: apiStatusContant.initial}

    componentDidMount() {
        this.getWeatherReport()
    }
    getWeatherReport = async () => {
        this.setState({apiStatus: apiStatusContant.inProgress})
        const {changeTemp,inputValue} = this.state
        const key = "3a7d3673b61940f6aaf102259240412"
        const url = `https://api.weatherapi.com/v1/current.json?key=${key}&q=${inputValue}&units=metric`
        const options = {
            method: "GET"
        }

        const response = await fetch(url,options)
        if (response.ok) {
            const data = await response.json()
            console.log(data)
            const updatedData = {
                temperature:changeTemp ?data.current.temp_f + " °F" : data.current.temp_c + " °C",
                humidity: data.current.humidity + "%",
                windSpeed:changeTemp ? data.current.wind_mph + " mph" : data.current.wind_kph + " kph",
                condition: data.current.condition,
                city: data.location.name,
            }
        this.setState({searchedData: updatedData,apiStatus: apiStatusContant.success})
        }else {
            this.setState({apiStatus: apiStatusContant.failure})
        }
    }

    onClickSwitch = () => {
        this.setState(prevState => ({ changeTemp: !prevState.changeTemp }),this.getWeatherReport)
    }

    onChangeInput = (event) => {
        this.setState({inputValue:event.target.value})
    }

    onClickSearch = () => {
        this.getWeatherReport()
    }

    renderSuccess = () => {
        const {searchedData} = this.state
        const isAvailable = Object.keys(searchedData).length !== 0
        return (
            <div>
                {isAvailable && (<WeatherList WeatherData={searchedData} />)}
            </div>
        )
    }

    renderLoading = () => (
        <div className="loading">
            <Vortex
  visible={true}
  height="80"
  width="80"
  ariaLabel="vortex-loading"
  wrapperStyle={{}}
  wrapperClass="vortex-wrapper"
  colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
  />
        </div>
    )

    

    renderResult = () => {
        const {apiStatus} = this.state

        switch (apiStatus) {
            case apiStatusContant.success:
                return this.renderSuccess()
            case apiStatusContant.inProgress:
                return this.renderLoading()
            default:
                return ""
        }
    }

    

    

    render () {
        const {inputValue,changeTemp} = this.state
        const switched = changeTemp ? "switch to Celsius" : "switch to Fahrenheit"
        
        return (
            <div className="mainContainer">
                <div className="weatherCard">
                    <h1 className="weatherheading">Weather Dashboard</h1>
                    <div className="searchContainer">
                        <input type="search" value={inputValue} placeholder="Enter City Name" className="searchBar" onChange={this.onChangeInput} />
                        <button type="button" className="searchButton" onClick={this.onClickSearch}>search</button>
                    </div>
                    <button type="button" className="switchButton" onClick={this.onClickSwitch}>{switched}</button>
                    {/* {isAvailable &&<WeatherList WeatherData={searchedData} />} */}
                    {this.renderResult()}

                </div>
            </div>
        )
    }
}

export default WeatherApp

